import React, { ReactNode } from 'react';
import { Box, BoxProps } from '../../next-components/box';
import { LazyImage, LazyImageProps, Placeholder as LazyImagePlaceholder } from '../lazyload';
import { Typography, TypographyProps } from '../Typography';
import { AuthorRelatedArticles, AuthorRelatedArticlesProps, RelatedArticle } from './next/AuthorRelatedArticles';
export type WellnessAuthorBlockProps = Omit<BoxProps, 'value'> & {
  containerProps?: BoxProps;
  imageProps?: LazyImageProps;
  nameProps?: TypographyProps;
  reviewedByProps?: TypographyProps;
  relatedArticlesProps?: AuthorRelatedArticlesProps;
  nameBlock?: ReactNode;
  value: {
    name: string;
    src: string;
    publishedDate: string;
    editedDate: string;
    breed?: string;
    reviewedBy?: string;
    relatedArticles?: RelatedArticle[];
  };
};
export const WellnessAuthorBlock = ({
  value: {
    src,
    name,
    breed,
    reviewedBy,
    publishedDate,
    editedDate,
    relatedArticles
  },
  containerProps,
  imageProps,
  nameProps,
  reviewedByProps,
  relatedArticlesProps,
  nameBlock,
  ...rest
}: WellnessAuthorBlockProps) => <Box display="grid" gridGap="24px" {...rest} data-sentry-element="Box" data-sentry-component="WellnessAuthorBlock" data-sentry-source-file="WellnessAuthorBlock.tsx">
    <Box display="grid" gridTemplateColumns={['72px 1fr']} gridGap="8px" alignItems="center" {...containerProps} data-sentry-element="Box" data-sentry-source-file="WellnessAuthorBlock.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="WellnessAuthorBlock.tsx">
        <LazyImage src={src} height="72px" width="72px" bg="none" overflow="unset" alt={`${name} avatar`} imageProps={{
        width: '72px',
        borderRadius: '50%'
      }} placeholder={<LazyImagePlaceholder width="72px" borderRadius="50%" />} {...imageProps} data-sentry-element="LazyImage" data-sentry-source-file="WellnessAuthorBlock.tsx" />
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="WellnessAuthorBlock.tsx">
        {nameBlock || <Typography m={0} fontSize="16px" maxWidth={['270px', '100%']} {...nameProps}>
            By&nbsp;
            {breed && <>
                {`a ${breed} lover`}
&nbsp;
              </>}
            <Box as="b" fontFamily="muliBold">
              {name}
            </Box>
          </Typography>}
        <Typography m={0} fontSize="16px" data-sentry-element="Typography" data-sentry-source-file="WellnessAuthorBlock.tsx">
          {`Published: ${publishedDate}, edited: ${editedDate}`}
        </Typography>
        {reviewedBy && <Typography m={0} fontSize="16px" {...reviewedByProps}>
            Reviewed by a licensed veterinary professional:
            {' '}
            <Box as="b" fontFamily="muliBold">
              {reviewedBy}
            </Box>
          </Typography>}
      </Box>
    </Box>
    {(!relatedArticles || !!relatedArticles.length) && <AuthorRelatedArticles value={{
    articles: relatedArticles,
    name
  }} {...relatedArticlesProps} />}
  </Box>;